<template>
  <div class="calculadora-component">
    <b-container>
      <h1>Calculadora</h1>
      <b-card-group columns class="mb-5">
        <b-card no-body v-for="(grupo) in grupos" :key="grupo.nombre">
          <b-card-header header-class="p-1">
            <b-button block variant="outline-success" v-b-toggle="`${grupo.id}`">{{ grupo.nombre }}</b-button>
          </b-card-header>
          <b-collapse :id="`${grupo.id}`">
            <b-list-group flush>
              <b-list-group-item button @click="togglProd(prod.grupo, prod.nombre)" v-for="prod in grupo.productos" :key="prod.nombre" :variant="seleccionados[prod.grupo + '.' + prod.nombre]?'success':''">{{ prod.nombre }} <span v-if="!!seleccionados[prod.grupo + '.' + prod.nombre]">✓︎</span></b-list-group-item>
            </b-list-group>
          </b-collapse>
        </b-card>
      </b-card-group>
      <!-- <b-form-group>
        <b-form-radio-group v-model="stacked">
          <b-form-radio :value="true">Stacked</b-form-radio>
          <b-form-radio :value="false">Responsive</b-form-radio>
        </b-form-radio-group>
      </b-form-group> -->
    </b-container>
    <div class="fixed-bottom">
      <b-collapse id="tabla" class="pt-3 bg-dark-blue-grey-50">
        <b-table bordered small dark striped responsive :stacked="stacked" class="calculadora-totales" :fields="totalesFields" :items="totales()">
          <template slot="prodQty" slot-scope="data" class="text-left">
            {{ data.item.qty > 1 ? `${data.item.qty} ` : '' }}{{ data.item.prod }} <b-btn v-if="data.item.prod !== 'Total'" variant="link" size="sm" @click="removeProd(data.item.grupo, data.item.prod)">✗</b-btn>
          </template>
          <template slot="veget" slot-scope="data">{{ data.item.veget | siNo }}</template>
          <template slot="vegan" slot-scope="data">{{ data.item.vegan | siNo }}</template>
          <template slot="sinlact" slot-scope="data">{{ data.item.sinlact | siNo }}</template>
          <template slot="sintrigo" slot-scope="data">{{ data.item.sintrigo | siNo }}</template>
          <template slot="nota" slot-scope="data">
            <b-btn v-if="data.item.nota" variant="link" size="sm" v-b-popover.top.hover.blur="data.item.nota">ver</b-btn>
          </template>
          <template slot="HEAD_cal" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_carb" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_grasa" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_prot" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_frut" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_verd" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_lact" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_veget" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_vegan" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_sinlact" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_sintrigo" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="HEAD_nota" slot-scope="data"><div><span>{{data.label | metricReadable}}</span></div></template>
          <template slot="FOOT_prodQty" slot-scope="data">
            <b>{{data.label}}</b>
          </template>
        </b-table>
        <b-container class="pb-1">
          <p>*: Modificable (ver nota)</p>
        </b-container>
      </b-collapse>
      <b-navbar type="dark" variant="primary">
        <b-nav-text>Total:</b-nav-text>
        <b-badge variant="light" class="text-uppercase" v-for="(value, metric) in suma()" :key="metric">{{metric | metricReadable}}: {{value}}</b-badge>
        <b-btn v-b-toggle.tabla variant="secondary">desglose</b-btn>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import GetSheetDone from 'get-sheet-done'

const SUMA_DEF_PROPS = {
  cal: 0,
  carb: 0,
  grasa: 0,
  prot: 0,
  frut: 0,
  verd: 0,
  lact: 0,
}
const ITEM_DEF_PROPS = {
  ...SUMA_DEF_PROPS,
  veget: 0,
  vegan: 0,
  sinlact: 0,
  sintrigo: 0
};

export default {
  name: 'Calculadora',
  data: () => {
    return {
      stacked: false,
      seleccionados: {},
      totalesFields: [
        { key:'prodQty', label:'', isRowHeader: true },
        { key: 'cal', label: 'cal', class: 'rotate' },
        { key: 'carb', label: 'carb', class: 'rotate' },
        { key: 'grasa', label: 'gras', class: 'rotate' },
        { key: 'prot', label: 'prot', class: 'rotate' },
        { key: 'frut', label: 'frut', class: 'rotate' },
        { key: 'verd', label: 'verd', class: 'rotate' },
        { key: 'lact', label: 'lact', class: 'rotate' },
        { key: 'veget', label: 'veget', class: 'rotate' },
        { key: 'vegan', label: 'vegan', class: 'rotate' },
        { key: 'sinlact', label: 'sin lact', class: 'rotate' },
        { key: 'sintrigo', label: 'sin trigo', class: 'rotate' },
        { key: 'nota', label: 'nota', class: 'rotate' }
      ],
      grupos: []
    }
  },
  created: function () {
    const self = this
    // 1Nd3d9sofhtNEyXLGehTVmtVvv7BFOUZBIQ6eEyCPo6A
    GetSheetDone.labeledCols('1Nd3d9sofhtNEyXLGehTVmtVvv7BFOUZBIQ6eEyCPo6A').then(sheet => {
      const gruposDict = {}
      let iter = 0
      if (process.env.NODE_ENV === 'development') console.log('Debug:\n', sheet)
      for (let row of sheet.data) {
        // si no existe el grupo lo creamos
        if (gruposDict[row.grupo] === void 0) {
          gruposDict[row.grupo] = {
            id: `grupo-${iter++}`,
            nombre: row.grupo,
            productos: []
          }
        }
        // agregamos el producto al grupo
        gruposDict[row.grupo].productos.push(row)
      }
      self.grupos = Object.values(gruposDict)
    })
  },
  filters: {
    siNo: function (value) {
      switch (+value) {
        case 0:
          return '';
        case 1:
          return '✓';
        case 2:
          return '*'
      }
      return '';
    },
    metricReadable: function (metric) {
      let result;
      switch (metric) {
        case 'cal':
          result = 'Calorías'
          break
        case 'carb':
          result = 'Carbos'
          break
        case 'prot':
          result = 'Proteinas'
          break
        case 'frut':
          result = 'Frutas'
          break
        case 'verd':
          result = 'Verduras'
          break
        case 'lact':
          result = 'Lácteos'
          break
        case 'veget':
          result = 'Vegetariano'
          break
        case 'vegan':
          result = 'Vegano'
          break
        case 'grasa':
          result = 'Grasa';
          break
        case 'sinlact':
          result = 'Sin lácteos';
          break
        case 'sintrigo':
          result = 'Sin trigo';
          break
        default:
          result = metric;
          break
      }
      return result;
    }
  },
  methods: {
    togglProd: function (grupo, nombre) {
      const key = grupo + '.' + nombre
      if (!this.seleccionados[key]) this.seleccionados[key] = 1;
      else this.seleccionados[key] = 0;
      this.$forceUpdate()
    },
    removeProd: function (grupo, nombre) {
      const key = grupo + '.' + nombre
      if (this.seleccionados[key]) this.seleccionados[key] = 0;
      this.$forceUpdate()
    },
    sumar: function () {
      let qty;
      let temp = { ...ITEM_DEF_PROPS };
      const totales = [];
      // const suma = {prod: 'Total', ...ITEM_DEF_PROPS};
      const suma = {...SUMA_DEF_PROPS};
      for (let selProd in this.seleccionados) {
        let selProdGrupo = selProd.split('.')[0]
        let selProdNombre = selProd.split('.')[1]
        for (let grupo of this.grupos) {
          for (let prod of grupo.productos) {
            if (selProdNombre === prod.nombre && selProdGrupo === grupo.nombre) {
              qty = this.seleccionados[selProd];
              if (qty > 0) {
                temp = {
                  cal: prod.cal * qty,
                  carb: prod.carb * qty,
                  grasa: prod.grasa * qty,
                  prot: prod.prot * qty,
                  frut: prod.frut * qty,
                  verd: prod.verd * qty,
                  lact: prod.lact * qty,
                  veget: prod.veget,
                  vegan: prod.vegan,
                  sinlact: prod.sinlact,
                  sintrigo: prod.sintrigo,
                  nota: prod.nota
                };
                totales.push({
                  prod: selProdNombre,
                  grupo: selProdGrupo,
                  qty,
                  ...temp
                });
                suma.cal += temp.cal;
                suma.carb += temp.carb;
                suma.grasa += temp.grasa;
                suma.prot += temp.prot;
                suma.frut += temp.frut;
                suma.verd += temp.verd;
                suma.lact += temp.lact;
                break;
              }
            }
          }
        }
      }
      totales.push({prod: 'Total', ...suma});
      return {totales, suma};
    },
    // estos dos son method's y no computed's porque si no no se refrescan
    totales: function () {
      return this.sumar().totales;
    },
    suma: function () {
      return this.sumar().suma;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.calculadora-totales /deep/ table {
  margin-left: 1rem;
  margin-right: 1rem;
}

.calculadora-totales /deep/ th {
  text-transform: uppercase;
}

.calculadora-totales /deep/ th.rotate {
  /* Something you can count on */
  height: 120px;
  white-space: nowrap;
}

.calculadora-totales /deep/ th.rotate > div {
  transform: 
    /* Magic Numbers */
    // translate(25px, 51px)
    // translate(-1px, 0)
    /* 45 is really 360 - 45 */
    rotate(270deg);
  width: 30px;
}

.calculadora-totales /deep/ th.rotate > div > span {
  // border-bottom: 1px solid #ccc;
  padding: 0 10px;
}
</style>
